const patternNumero2Decimales = /^\d+(\.\d{0,2})?$/;
const patternNumero3Decimales = /^\d+(\.\d{0,3})?$/;
const patternNumero4Decimales = /^\d+(\.\d{0,4})?$/;

export { patternNumero2Decimales, patternNumero3Decimales, patternNumero4Decimales };
